import React, { useRef, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import { createTheme } from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import InfoIcon from '@mui/icons-material/Info';
import RefreshIcon from '@mui/icons-material/Refresh';
import Button from '@mui/material/Button';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Paper from '@mui/material/Paper';
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import axios from 'axios'
import DateFnsUtils from '@date-io/date-fns';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import LinearProgress from '@mui/material/LinearProgress';
import {format} from 'date-fns';
import {MuiPickersUtilsProvider,KeyboardDatePicker,KeyboardTimePicker} from '@material-ui/pickers';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import EventIcon from '@mui/icons-material/Event';
import IconButton from '@mui/material/IconButton';
import MobileTimePicker from '@mui/lab/MobileTimePicker';

const materialTheme = createTheme(({
    // set default for now
}));

const useStyles = makeStyles((theme) => ({
    fullWidth: {
        width: "100%",
    },
    input: {

    },

}));

function MethodDelivery(props) {
   
    const classes = useStyles();
    const [isSavingTransaction,setIsSavingTransaction] = useState(false)
    const [isSavingTransactionSuccess,setIsSavingTransactionSuccess] = useState(false)
    const [showMessageDialog,setShowMessageDialog] = useState(false)
    const [messageDialogMessage,setMessageDialogMessage] = useState("")
    const [requestedDeliveryDate, setRequestedDeliveryDate] = React.useState(new Date());
    const [requestedDeliveryDateCalenderOpen, setRequestedDeliveryDateCalenderOpen] = useState(false);
    const [preparedDeliveryTime, setPreparedDeliveryTime] = useState(new Date());
    const [preparedDeliveryTimeCalenderOpen, setPreparedDeliveryTimeCalenderOpen] = useState(false);
    const [totalOrderedAmount,setTotalOrderedAmount] = useState(0)
    
    const [orderInformation,setOrderInformation] = useState({
        distributor_company_id:props.sellerCompanyId,
        request_delivery_date:format(new Date(), 'yyyy-MM-dd'),
        requested_delivery_time:format(new Date(), 'HH:mm:00'),
        dm_delivery_location:'',
        dm_contact_name:'',
        dm_contact_number:'',
        payment_type:'',
        order_items:getOrderItems()
        })


    const requestedDeliveryDateHandleDateChange = (date) => {
        setRequestedDeliveryDate(date);

        const newOrderInformation = {...orderInformation}
        newOrderInformation.request_delivery_date = format(date, 'yyyy-MM-dd')
        setOrderInformation(newOrderInformation)
        
    };

    
    const deliveryTimeHandleDateChange = (date) => {
        setPreparedDeliveryTime(date);
        const newOrderInformation = {...orderInformation}
        newOrderInformation.requested_delivery_time = format(date, 'H:mm:00')
        setOrderInformation(newOrderInformation)
    };

    const textFieldOnChange = (event)=>{
        const newOrderInformation = {...orderInformation}
        newOrderInformation[event.target.name] = event.target.value
        setOrderInformation(newOrderInformation)
    }

    function getOrderItems(){
        const temporaryOrderString = localStorage.getItem("temporary_order")
         if(temporaryOrderString == null){
            return []
         }
         
         const orderedProducts = JSON.parse(temporaryOrderString)
        
         const lessInfoOrderedProducts = [] 
         orderedProducts.forEach((product,index)=>{
            
              product.Units.forEach((unit,index)=>{
                if(unit.order_quantity > 0){
                    lessInfoOrderedProducts.push(unit)
                }
                
             })
         })

        
         
         return lessInfoOrderedProducts
    }
    function computeOverallTotalOrderedAmount(){
        const temporaryOrderString = localStorage.getItem("temporary_order")
         if(temporaryOrderString == null){
           return 0
         }
         const temporaryOrders = JSON.parse(temporaryOrderString)
         const overallTotalAmount = temporaryOrders.reduce((partialSum,product)=>partialSum + computeTotalOrderPerProduct(product),0.00).toFixed(2)
         
         return overallTotalAmount
         
    }
          
  function computeTotalOrderPerProduct(product){
    const totalOrderValue = Number(product.Units.reduce((partialSum,unit)=> partialSum + parseFloat(unit.order_quantity) * unit.price_with_tax,0.00 ))    
    return Number(totalOrderValue.toFixed(2))
  }

  function saveOrder(){

    setIsSavingTransaction(true)
    
    const options = {
        method: 'POST',
        url: '/Orders/saveOrderForDeliveryMethod.json',
        data: objectToFormData(orderInformation)
      }
       axios(options)
         .then(res => {
  
         
          const isSuccess = res.data.response.is_success
          if(!isSuccess){
            setIsSavingTransactionSuccess(false)
            setIsSavingTransaction(false)
            setMessageDialogMessage(res.data.response.message)
            setShowMessageDialog(true)

            return;
          }
          
          localStorage.removeItem("temporary_order")

          setIsSavingTransactionSuccess(true)
          setIsSavingTransaction(false)
          setMessageDialogMessage("Transaction save successfully.")
          setShowMessageDialog(true)

          //props.closeAllDialogs(res.data.response.message)
          
          
         }).catch(error => {
  
            setIsSavingTransaction(false)
            setIsSavingTransactionSuccess(false)

            alert("Error encounter")
           console.log(error)
  
         })
  }
  function progressDialog(){
      return(
        <Dialog
        fullWidth={true}
        maxWidth={'lg'}
        open={isSavingTransaction}
        onClose={()=>{}}
      >
       
        <DialogContent>
          <DialogContentText>
            Saving transaction... Please wait...
          </DialogContentText>
          <LinearProgress color="secondary" />
        </DialogContent>
      </Dialog>
      )
  }
  function messageDialog(){
      return(
        <Dialog
        fullWidth={true}
        maxWidth={'sm'}
        open={showMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           {messageDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{

              setShowMessageDialog(false)
              if(isSavingTransactionSuccess == true){
                props.closeAllDialogs("")
              }
              
              
              }} 
            color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      )
  }
  const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
     
      if(key == 'order_items'){
       object[key].forEach((order)=>{
            console.log(order)
            formData.append(key,JSON.stringify(object[key])) 
       })

      }else{
        formData.append(key, object[key]);
      }
    
    return formData;
  }, new FormData());
  useEffect(()=>{

    setTotalOrderedAmount(computeOverallTotalOrderedAmount())
 
  },[])
    return (
        <div>
            <Grid container spacing={1}>
                <Grid item xs={12} >Request Delivery Date</Grid>
                <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <MobileDatePicker
                               
                                inputFormat="MMMM d, yyyy"
                                value={requestedDeliveryDate}
                                open={requestedDeliveryDateCalenderOpen}
                                onChange={requestedDeliveryDateHandleDateChange}
                                onOpen={()=>{setRequestedDeliveryDateCalenderOpen(true)}}
                                onClose={()=>{setRequestedDeliveryDateCalenderOpen(false)}}
                                renderInput={(params) => 
                                    <TextField 
                                        {...params} 
                                        className={classes.fullWidth} 
                                        InputProps={{
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <IconButton edge="end" onClick={()=>{setRequestedDeliveryDateCalenderOpen(true)}}>
                                                  <EventIcon />
                                                </IconButton>
                                              </InputAdornment>
                                            ),
                                          }}
                                        />
                                    }
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                    </StyledEngineProvider>  


                </Grid>

                <Grid item xs={12} >Preferred Time</Grid>
                <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>

                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <MobileTimePicker
                                    value={preparedDeliveryTime}
                                    onClick={() => { setPreparedDeliveryTimeCalenderOpen(true) }}
                                    open={preparedDeliveryTimeCalenderOpen}
                                    onOpen={() => setPreparedDeliveryTimeCalenderOpen(true)}
                                    onClose={() => setPreparedDeliveryTimeCalenderOpen(false)}
                                    onChange={deliveryTimeHandleDateChange}
                                    renderInput={(params) =>
                                    <TextField 
                                    {...params} 
                                    className={classes.fullWidth} 
                                    InputProps={{
                                        endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton edge="end" onClick={()=>{setPreparedDeliveryTimeCalenderOpen(true)}}>
                                            <AccessTimeIcon />
                                            </IconButton>
                                        </InputAdornment>
                                        ),
                                    }}
                                    />
                                }
                                />
                        </LocalizationProvider>
                        </ThemeProvider>
                    </StyledEngineProvider>  
                </Grid>
                <Grid item xs={12} >Delivery Location</Grid>
             
                <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                            <TextField
                                name={"dm_delivery_location"}
                                className={classes.fullWidth}
                                id="outlined-multiline-static"
                                multiline
                                rows={4}
                                variant="outlined"
                                onChange={textFieldOnChange}
                            />
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Grid>
                <Grid item xs={12} >Contact Name</Grid>
                <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                            <TextField
                                name={"dm_contact_name"}
                                className={classes.fullWidth}
                                id="contact-name"
                                rows={4}
                                variant="outlined"
                                onChange={textFieldOnChange}
                            />
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Grid>
                <Grid item xs={12} >Contact Number</Grid>
                <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                            <TextField
                                name="dm_contact_number"
                                className={classes.fullWidth}
                                id="contact-number"
                                rows={4}
                                variant="outlined"
                                onChange={textFieldOnChange}
                            />
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Grid>

                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Delivery Charge</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <InfoIcon />
                    </Grid>
                </Grid>
                <Grid item container >
                    <Grid item xs container>
                        <Button variant="contained" color="primary">
                            Request Quote
                        </Button>
                        <Typography variant="h6" style={{ marginLeft: "1rem" }}>0</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <RefreshIcon />
                    </Grid>
                </Grid>

                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Other Charges</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <InfoIcon />
                    </Grid>
                </Grid>
                <Grid item container >
                    <Grid item xs container>
                        <Button variant="contained" color="primary">
                            Request Quote
                        </Button>
                        <Typography variant="h6" style={{ marginLeft: "1rem" }}>0</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <RefreshIcon />
                    </Grid>
                </Grid>

                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Payment Type</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <InfoIcon />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                            <TextField
                                name={"payment_type"}
                                className={classes.fullWidth}
                                id="contact-name"
                                rows={4}
                                variant="outlined"
                            />
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Grid>

                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Proof of Payment</Typography>
                    </Grid>
                </Grid>
                <Grid item container >
                    <input
                        accept="image/*"
                        id="contained-button-file"
                        type="file"
                    />
                </Grid>

                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Ordered Products</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                            <Typography variant="subtitle1">{Number(totalOrderedAmount).toLocaleString(undefined, {minimumFractionDigits:2,maximumFractionDigits:2})}</Typography>
                    </Grid>
                </Grid>
                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Delivery Charge</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <Typography variant="subtitle1">0.00</Typography>
                    </Grid>
                </Grid>
                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Other Charges</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <Typography variant="subtitle1">0.00</Typography>
                    </Grid>
                </Grid>
                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Discount</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <Typography variant="subtitle1">0.00</Typography>
                    </Grid>
                </Grid>
                <Grid item container >
                    <Grid item xs>
                        <Typography variant="subtitle1">Grand Total</Typography>
                    </Grid>
                    <Grid item style={{ marginRight: "1.5em" }}>
                        <Typography variant="subtitle1">{Number(totalOrderedAmount).toLocaleString(undefined, {minimumFractionDigits:2,maximumFractionDigits:2})}</Typography>
                    </Grid>
                </Grid>
                <Grid item container >
                <Button variant="contained" color="primary" style={{width:"100%"}} onClick={()=>{saveOrder()}}>
                    Place Order
                </Button>
                </Grid>
            </Grid>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                {progressDialog()}
                {messageDialog()}
                </ThemeProvider>
            </StyledEngineProvider>
        </div>
    );

}

export default MethodDelivery